module.exports = __webpack_public_path__ + "img/help_dataset_estimate.30f0a2c0.png";